import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import {ListEventData} from 'organization/EventList'

export default function UnarchiveEventButton(props: {
  event: ListEventData
  setShowUnarchiveDialog: (show: boolean) => void
}) {
  const {event, setShowUnarchiveDialog} = props

  return (
    <MenuItem
      aria-label="unarchive event"
      disabled={event.is_deleting}
      onClick={() => {
        setShowUnarchiveDialog(true)
      }}
    >
      Unarchive
    </MenuItem>
  )
}
